namespace GeniuzPOS.Purchase {
    export class PoPo05PendingPIforIrColumns {
        static columnsKey = 'Purchase.PoPo05PendingPIforIr';
    }
}
